import { ApiCall } from 'omni-common-ui';
import { fetch, buildUrl } from 'domain/Api';

export const FETCH_HOMEWORK_TEMPLATE_REQUEST = 'FETCH_HOMEWORK_TEMPLATE_REQUEST';
export const FETCH_HOMEWORK_TEMPLATE_SUCCESS = 'FETCH_HOMEWORK_TEMPLATE_SUCCESS';
export const FETCH_HOMEWORK_TEMPLATE_FAILURE = 'FETCH_HOMEWORK_TEMPLATE_FAILURE';

const buildHomeworkTemplateUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/homework-template`);

export function fetchHomeworkTemplateIfNeeded(sessionId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildHomeworkTemplateUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchHomeworkTemplate(sessionId));
  };
}

export function fetchHomeworkTemplate(sessionId) {
  return (dispatch) => {
    const url = buildHomeworkTemplateUrl(sessionId);
    const method = 'GET';

    return dispatch(fetchHomeworkTemplateRequest()).payload
      .then((response) => dispatch(fetchHomeworkTemplateSuccess(response)))
      .catch((error) => dispatch(fetchHomeworkTemplateFailure(error)));

    function fetchHomeworkTemplateRequest() {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_TEMPLATE_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchHomeworkTemplateSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_TEMPLATE_SUCCESS,
        payload: response,
        url,
        method,
        sessionId,
      });
    }

    function fetchHomeworkTemplateFailure(error) {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_TEMPLATE_FAILURE,
        url,
        method,
        sessionId,
        error,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Homework/Template/actions.js